import React, { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar as MuiAppBar,
  Box,
  Typography,
  Button,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const MENU_BUTTONS = [
  {
    href: "/",
    text: "Home",
    anchors: null
  },
  {
    href: "/aboutus",
    text: "About Us",
    anchors: [
      "board-of-directors",
      "history-of-san-pedro",
      "articles-of-incorporation",
      "duties-of-the-board"
    ]
  },
  {
    href: "/contactus",
    text: "Contact Us",
    anchors: null
  },
  {
    href: "/events",
    text: "Events",
    anchors: null
  },
  {
    href: "/gallery",
    text: "Gallery",
    anchors: null
  },
  {
    href: "/links",
    text: "Links",
    anchors: null
  },
  {
    href: "/parkrentals",
    text: "Park Rentals",
    anchors: null
  },
  {
    href: "/getinvolved",
    text: "Friends Of San Pedro",
    anchors: null
  }
]

function ToolbarButton({ href, text }) {
  const [style, setStyle] = useState({})

  const onMouseLeave = (event) => {
    setStyle({})
  }
  const onMouseEnter = (event) => {
    setStyle({
      borderBottom: "5px solid white",
      marginBottom: "-5px"
    })
  }
  return (
    <div
      style={style}
    >
      <Button
        color="inherit" href={href}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{ fontFamily: "'Cinzel', serif" }}
      >
        {text}
      </Button>
    </div>
  )
}

export default function MenuBar() {
  const [mobileOpen, setMobileOpen] = useState(false)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const toggleMobileMenu = () => {
    setMobileOpen(!mobileOpen)
  }

  const closeMobileMenu = () => {
    setMobileOpen(false)
  }

  return (
    <>
      <MuiAppBar
        id="menu-bar"
        position="sticky"
      >
        <Toolbar style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: isMobile ? "center" : "space-between",
          paddingLeft: isMobile ? "12px" : "10%",
          paddingRight: isMobile ? "12px" : "10%",
          minHeight: isMobile ? 56 : 64
        }}>
          {
            isMobile
              ? (
                <IconButton
                  color="inherit"
                  aria-label="open navigation menu"
                  onClick={toggleMobileMenu}
                  style={{ borderRadius: 8, paddingLeft: 12, paddingRight: 12 }}
                >
                  <MenuIcon />
                  <Typography
                    component="span"
                    style={{ marginLeft: 8, fontWeight: 600 }}
                  >
                    Menu
                  </Typography>
                </IconButton>
              )
              : MENU_BUTTONS.map(button => (
                <ToolbarButton key={button.href} href={button.href} text={button.text} />
              ))
          }
        </Toolbar>
      </MuiAppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={closeMobileMenu}
      >
        <Box
          role="presentation"
          onClick={closeMobileMenu}
          style={{ width: 280 }}
        >
          <List>
            {
              MENU_BUTTONS.map(button => (
                <ListItemButton
                  component="a"
                  href={button.href}
                  key={button.href}
                >
                  <ListItemText
                    primary={button.text}
                    primaryTypographyProps={{ style: { fontFamily: "'Cinzel', serif" } }}
                  />
                </ListItemButton>
              ))
            }
          </List>
        </Box>
      </Drawer>
    </>
  )

}
